import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { recalculateCoordinates } from "sources/admin";
import Form from "./form";
import List from "./list";

export default class CalculationQueues extends Component {
    componentWillUnmount() {
        this.props.clearParams("calculationqueues");
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List {...this.props} isTable transition="full" title="Перерасчет заявок" nofilter />
                        )}
                    />
                    <Route
                        path={`${rootUrl}/new`}
                        render={() => (
                            <Form
                                {...this.props}
                                transition="full"
                                title="Перерасчет пробегов"
                                back={back}
                                submit={recalculateCoordinates}
                            />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}
